module.exports = function (app) {
  app.channel.on('goto:all-offers', async (data) => {
    const AmexOffers = (await import(/* webpackChunkName: "amex-offers" */ `@feature/credit-gateway/src/${process.env.ENTRY_POINT}/pages/AmexOffers/AmexOffersPage`)).default;
    app.AmexOffersView = new AmexOffers({
      el: '#amex-container',
      brand: app.brand,
      last4digits: data.last4digits,
      regAmexGuid: data.regAmexGuid,
      container: data.container,
      cardIndex: data.cardIndex,
    }).view;
    app.AmexOffersView.render();
    app.channel.trigger('all-offers:loaded'); // for testing
  });
};
